const APIKEY = "02080e7b37e5a4c0d8c183e61b4109f1";
const baseURL = "https://api.themoviedb.org/3";

const requests = {
  fetchTrending: `${baseURL}/trending/all/week?api_key=${APIKEY}&language=en-US`, //
  fetchNetflixOriginals: `${baseURL}/discover/tv?api_key=${APIKEY}&with_networks=213`, //
  fetchTopRated: `${baseURL}/movie/top_rated?api_key=${APIKEY}&language=en-US`,
  fetchActionMovies: `${baseURL}/discover/tv?api_key=${APIKEY}&with_genres=28`,
  fetchComedyMovies: `${baseURL}/discover/tv?api_key=${APIKEY}&with_genres=35`,
  fetchHorrorMovies: `${baseURL}/discover/tv?api_key=${APIKEY}&with_genres=27`,
  fetchRomanceMovies: `${baseURL}/discover/tv?api_key=${APIKEY}&with_genres=10749`,
  fetchDocumentaries: `${baseURL}/discover/tv?api_key=${APIKEY}&with_genres=99`,
};

export default requests;

//Example: https://api.themoviedb.org/3/movie/550?api_key=02080e7b37e5a4c0d8c183e61b4109f1
//https://api.themoviedb.org/3/trending/all/week?api_key=02080e7b37e5a4c0d8c183e61b4109f1&language=en-US
